import React from 'react'
import 'babel-polyfill';
import ReactDOM from 'react-dom'
import {AppContainer} from 'react-hot-loader'
import Routes from './routes'
import ReactGA from 'react-ga';
import * as serviceWorker from './serviceWorker';
import StateProvider from "./containers/StateProvider";

ReactGA.initialize('UA-133740716-1');
ReactGA.pageview(window.location.pathname + window.location.search);

window.addEventListener("orientationchange", function() {
  document.body.style.width = window.innerWidth;
});

const renderApp = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('app')
  );
};

const App = (props) => {
  return (
    <StateProvider {...props}>
      <Routes />
    </StateProvider>
  )
}

renderApp(App);

serviceWorker.unregister();
